import { useTranslationWithNamespace } from './useTranslationWithNamespace';

export const useLocale = (code: string) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const t = getLocalizeCurried(code);

	return { t };
};
